import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {LoginService} from "./login.service";
import {Global} from "../global";
import {FormBuilder, Validators, FormGroup} from "@angular/forms";
import {BasicValidators} from "../shared/basic-validators";
import {UsuariosService} from "../usuarios/usuarios.service";
import {Funcoes} from "../funcoes";
import {Headers} from "@angular/http";
import {LoginClienteService} from "./login-cliente.service";
import {ClientesUsuariosService} from "../clientes-usuarios/clientes-usuarios.service";

import { ConfiguracoesService } from "../configuracoes/configuracoes.service";

declare var $:any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  usuario: string;
  senha: string;
  nomeSistema: string;
  copyright: string;
  logoPainelUrl: string = '';

  emailUsuarioLembrar: string;

  formAtiv: FormGroup;
  formTrocaSenha: FormGroup;

  constructor(
    formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private loginClienteService: LoginClienteService,
    public global: Global,
    private usuariosService: UsuariosService,
    private clientesUsuariosService: ClientesUsuariosService,
    private configService: ConfiguracoesService
  ) {
    this.nomeSistema = global.nomeSistema;
    this.copyright = global.copyright;

    this.formAtiv = formBuilder.group({
      cod: ['', [
        Validators.required
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
      senha: ['', [Validators.minLength(8)]],
      senha_conf: ['', BasicValidators.igualSenha]
    });

    this.formTrocaSenha = formBuilder.group({
      cod: ['', [
        Validators.required
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
      senha: ['', [Validators.minLength(8)]],
      senha_conf: ['', BasicValidators.igualSenha]
    });
  }

  get logoUrl(): string {
    let url = this.global.logoLoginUrl || '';
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    return this.global.dominio_site + (url.startsWith('/') ? '' : '/') + url;
  }

  ngOnInit() {
    this.carregarConfiguracoes();

    this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        if(param['email'] && param['cod']){
          $('#modalConfirmarCadastro').modal('show');
          this.formAtiv.patchValue({email: param['email']});
          this.formAtiv.patchValue({cod: param['cod']});
          return;
        }

        if(param['email'] && param['codigo']){
          $('#modalTrocarSenha').modal('show');
          this.formTrocaSenha.patchValue({email: param['email']});
          this.formTrocaSenha.patchValue({cod: param['codigo']});
          return;
        }

        let userParam = param['email'] || param['usuario'];
        let passParam = param['senha'] || param['password'];
        if (userParam && passParam) {
          this.usuario = userParam;
          this.senha = passParam;
          this.logar();
        }
      });
  }

  carregarConfiguracoes() {
    this.configService.getConfiguracoes().subscribe(
      (json: any) => {
        if (json && json.Payload && json.Payload.length > 0) {
          let item = Array.isArray(json.Payload[0]) ? json.Payload[0][0] : json.Payload[0];
          if (item && item.nome_sistema) {
            this.nomeSistema = item.nome_sistema;
          }
        }
      },
      error => {}
    );
  }

  logar() {

    let servico;

    if(this.activatedRoute.url['value'][0].path == 'login-cliente' || this.activatedRoute.url['value'][0].path == 'nao-autorizado-cliente'){
      servico = this.loginClienteService;
    }else{
      servico = this.loginService;
    }

    servico.login(this.usuario, this.senha).subscribe((result) => {

      if (result.Success) {

        servico.serverUserInfo()
          .subscribe(data => {
            servico.userInfo = data;

            if(this.activatedRoute.url['value'][0].path == 'login-cliente' || this.activatedRoute.url['value'][0].path == 'nao-autorizado-cliente'){
              let isTipo8 = false;
              if (data && data.cliente && data.cliente.tipos) {
                isTipo8 = data.cliente.tipos.some(t => String(t.id_tipo) === '8');
              }
              if (isTipo8) {
                this.router.navigate(['/painel', 'area-cliente', 'meus-testes-sopro']);
              } else {
                this.router.navigate(['/painel', 'area-cliente', 'minhas-fichas']);
              }
            }else{
              this.router.navigate(['/painel', 'dashboard']);
            }
          },
          error => {
            servico.trataErro(error.json());
          });
      }
    },
    (erro) => this.loginService.trataErro(erro.json()));
  }

  ativarConta() {
    let form = this.formAtiv.value;

    let servico;

    if(this.activatedRoute.url['value'][0].path == 'login-cliente' || this.activatedRoute.url['value'][0].path == 'nao-autorizado-cliente'){
      servico = this.clientesUsuariosService;
    }else{
      servico = this.usuariosService;
    }

    servico.confirmarCadastro(form).subscribe((result) => {
        $('#modalConfirmarCadastro').modal('hide');
      },
      (erro) => servico.trataErro(erro.json()));
  }

  modalEsqueceuSenha(){

    let servico;

    if(this.activatedRoute.url['value'][0].path == 'login-cliente' || this.activatedRoute.url['value'][0].path == 'nao-autorizado-cliente'){
      servico = this.clientesUsuariosService;
    }else{
      servico = this.usuariosService;
    }

    servico.solicitarNovaSenha(this.emailUsuarioLembrar).subscribe((result) => {
        $('#modalLembrarSenha').modal('hide');
        this.emailUsuarioLembrar = '';
      },
      (erro) => servico.trataErro(erro.json()));
  }

  trocarSenha(){

    let form = this.formTrocaSenha.value;

    let servico;

    if(this.activatedRoute.url['value'][0].path == 'login-cliente' || this.activatedRoute.url['value'][0].path == 'nao-autorizado-cliente'){
      servico = this.clientesUsuariosService;
    }else{
      servico = this.usuariosService;
    }

    servico.salvarNovaSenha(form).subscribe((result) => {
        $('#modalTrocarSenha').modal('hide');
      },
      (erro) => servico.trataErro(erro.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts